import { DeleteRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useGetAddtional } from "./useGetAddtional"
import { AddtionalEntity } from "../../Objects/Addtional/AddtionalEntity"
import { useTranslation } from "react-i18next"

export const useRemoveAddtional = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetAddtional } = useGetAddtional()

  const handleRemove = async (addtional: AddtionalEntity, onSuccess: any) => {
    try {
      enableLoad()

      var response = await DeleteRequest(`${API_ROUTES.ADDTIONAL.DELETE}/${addtional.id}`)

      if (response.success) {
        await handleGetAddtional(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleRemove,
  }
}
